import React, { useEffect, useState } from 'react';
import { Col, Row, Input, Label, Button } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../';
import { removeMainEngineRow, setMainEngineRow } from '../../Store/Generic/ReportingSlice';
import { VesselMachineryConstant } from 'shared/constants';

const MainEnginesRow = (props: any) => {
  const [mainEngine] = useState<Array<any>>([]);
  const { mainEng, vesselEngine, mainEngines, index } = props;
  const { VesselID, MainEngineRow } = useSelector((state: RootState) => state.Reporting);
  const [fpp, setFpp] = useState(false);
  const [engineType, setEngineType] = useState('');
  const [propellerType, setPropellerType] = useState('');
  const [shaftPower, setShaftPower] = useState(0.0);
  const [propellerPitch, setPropellerPitch] = useState(0.0);
  const [eedi, setEedi] = useState(0.0);
  const [eexi, setEexi] = useState(0.0);

  const dispatch = useDispatch();

  useEffect(() => {
    mainEngines.map((engine: any, index: number) => {
      if (mainEngine.length <= mainEngines.length) {
        return (
          mainEngine.splice(index, 0, {
            engine_type: '2_stroke', propeller_type: "controllable_pitch_propeller", shaft_power: 0, eedi: 0, eexi: 0, propeller_pitch: null, machinery_name: engine.id, vessel_name: VesselID
          })
        )
      }
      return '';
    })

    mainEngines.map((main: any) => (
      mainEng.filter((item: any) => item.machinery_name === main.id).map((eng: any) => {
        if (eng.propeller_type === 'fixed_pitch_propeller') {
          setFpp(true);
        } else {
          setFpp(false);
        }
        return '';
      })
    ))
  }, [mainEngines, VesselID])

  function handle_2_Stroke_Main_Engine_Changes(e: any, idx: number, machine_id: number) {
    mainEngine[idx].engine_type = e.target.value
    setEngineType(e.target.value);
    if (MainEngineRow.length > 0) {
      const row: any = MainEngineRow.find((item: any) => item.machinery_name === machine_id);
      const indx = MainEngineRow.indexOf(row);
      dispatch(removeMainEngineRow(indx));
    }
    dispatch(setMainEngineRow({
      engine_type: e.target.value, propeller_type: propellerType, shaft_power: shaftPower, eedi: eedi, eexi: eexi, propeller_pitch: propellerPitch, machinery_name: machine_id, vessel_name: VesselID
    }));
  }

  function handle_4_Stroke_Main_Engine_Changes(e: any, idx: number, machine_id: number) {
    mainEngine[idx].engine_type = e.target.value
    setEngineType(e.target.value);
    if (MainEngineRow.length > 0) {
      const row: any = MainEngineRow.find((item: any) => item.machinery_name === machine_id);
      const indx = MainEngineRow.indexOf(row);
      dispatch(removeMainEngineRow(indx));
    }
    dispatch(setMainEngineRow({
      engine_type: engineType, propeller_type: e.target.value, shaft_power: shaftPower, eedi: eedi, eexi: eexi, propeller_pitch: propellerPitch, machinery_name: machine_id, vessel_name: VesselID
    }));
  }

  function handle_Shaft_Power_Main_Engine_Changes(e: any, idx: number, machine_id: number) {
    mainEngine[idx].shaft_power = parseFloat(e.target.value)
    setShaftPower(parseFloat(e.target.value));
    if (MainEngineRow.length > 0) {
      const row: any = MainEngineRow.find((item: any) => item.machinery_name === machine_id);
      const indx = MainEngineRow.indexOf(row);
      dispatch(removeMainEngineRow(indx));
    }
    dispatch(setMainEngineRow({
      engine_type: engineType, propeller_type: propellerType, shaft_power: parseFloat(e.target.value), eedi: eedi, eexi: eexi, propeller_pitch: propellerPitch, machinery_name: machine_id, vessel_name: VesselID
    }));
  }

  function handle_EEDI_Main_Engine_Changes(e: any, idx: number, machine_id: number) {
    mainEngine[idx].eedi = parseFloat(e.target.value)
    setEedi(parseFloat(e.target.value));
    if (MainEngineRow.length > 0) {
      const row: any = MainEngineRow.find((item: any) => item.machinery_name === machine_id);
      const indx = MainEngineRow.indexOf(row);
      dispatch(removeMainEngineRow(indx));
    }
    dispatch(setMainEngineRow({
      engine_type: engineType, propeller_type: propellerType, shaft_power: shaftPower, eedi: parseFloat(e.target.value), eexi: eexi, propeller_pitch: propellerPitch, machinery_name: machine_id, vessel_name: VesselID
    }));
  }

  function handle_EEXI_Main_Engine_Changes(e: any, idx: number, machine_id: number) {
    mainEngine[idx].eexi = parseFloat(e.target.value)
    setEexi(e.target.value);
    if (MainEngineRow.length > 0) {
      const row: any = MainEngineRow.find((item: any) => item.machinery_name === machine_id);
      const indx = MainEngineRow.indexOf(row);
      dispatch(removeMainEngineRow(indx));
    }
    dispatch(setMainEngineRow({
      engine_type: engineType, propeller_type: propellerType, shaft_power: shaftPower, eedi: eedi, eexi: parseFloat(e.target.value), propeller_pitch: propellerPitch, machinery_name: machine_id, vessel_name: VesselID
    }));
  }

  function handle_Controllable_Propeller_Main_Engine_Changes(e: any, idx: number, machine_id: number) {
    mainEngine[idx].propeller_type = e.target.value
    setPropellerType(e.target.value);
    if (MainEngineRow.length > 0) {
      const row: any = MainEngineRow.find((item: any) => item.machinery_name === machine_id);
      const indx = MainEngineRow.indexOf(row);
      dispatch(removeMainEngineRow(indx));
    }
    dispatch(setMainEngineRow({
      engine_type: engineType, propeller_type: e.target.value, shaft_power: shaftPower, eedi: eedi, eexi: eexi, propeller_pitch: propellerPitch, machinery_name: machine_id, vessel_name: VesselID
    }));
    setFpp(false)
  }

  function handle_Fixed_Propeller_Main_Engine_Changes(e: any, idx: number, machine_id: number) {
    setPropellerType(e.target.value);
    if (MainEngineRow.length > 0) {
      const row: any = MainEngineRow.find((item: any) => item.machinery_name === machine_id);
      const indx = MainEngineRow.indexOf(row);
      dispatch(removeMainEngineRow(indx));
    }
    dispatch(setMainEngineRow({
      engine_type: engineType, propeller_type: e.target.value, shaft_power: shaftPower, eedi: eedi, eexi: eexi, propeller_pitch: propellerPitch, machinery_name: machine_id, vessel_name: VesselID
    }));
    setFpp(true)
  }

  function handlePitchChanges(e: any, idx: number, machine_id: number) {
    mainEngine[idx].propeller_pitch = e.target.value
    setPropellerPitch(parseFloat(e.target.value));
    if (MainEngineRow.length > 0) {
      const row: any = MainEngineRow.find((item: any) => item.machinery_name === machine_id);
      const indx = MainEngineRow.indexOf(row);
      dispatch(removeMainEngineRow(indx));
    }
    dispatch(setMainEngineRow({
      engine_type: engineType, propeller_type: propellerType, shaft_power: shaftPower, eedi: eedi, eexi: eexi, propeller_pitch: parseFloat(e.target.value), machinery_name: machine_id, vessel_name: VesselID
    }));
  }

  return (
    <>
      <Row>
        <Col lg={6}>
          <Row>
            <Label className='bold_lbl'>Engine Type</Label>
            {vesselEngine?.machinery_name === VesselMachineryConstant.MAIN_ENGINE ?
              <>
                <Col lg={3}>
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="engineType"
                      id="2stroke"
                      value="2_stroke"
                      defaultChecked={mainEng.length > 0 ? mainEng.filter((item: any) => item.machinery_name === vesselEngine.id)
                        .map((eng: any) => eng.engine_type === '2_stroke')[0] : false}
                      onChange={(e: any) => handle_2_Stroke_Main_Engine_Changes(e, index, vesselEngine.id)}
                    />
                    <label className="form-check-label" htmlFor="2stroke">
                      2 stroke
                    </label>
                  </div>
                </Col>
                <Col>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="engineType"
                      value="4_stroke"
                      defaultChecked={mainEng.length > 0 ? mainEng.filter((item: any) => item.machinery_name === vesselEngine.id)
                        .map((eng: any) => eng.engine_type === '4_stroke')[0] : false}
                      onChange={(e: any) => handle_4_Stroke_Main_Engine_Changes(e, index, vesselEngine.id)}
                    />
                    <label className="form-check-label" htmlFor="4stroke">
                      4 stroke
                    </label>
                  </div>
                </Col>
              </> :
              <Label>Steam Turbine Type</Label>
            }
          </Row>
        </Col>
        <Col lg={4}>
          <div className="form-floating input-group mb-3">
            <Input
              type="text"
              className="form-control"
              id={vesselEngine.id}
              name="shaft_power"
              placeholder='example'
              defaultValue={mainEng.length > 0 ? mainEng.filter((item: any) => item.machinery_name === vesselEngine.id).map((eng: any) => { return eng.shaft_power }) : null}
              onBlur={(e) => handle_Shaft_Power_Main_Engine_Changes(e, index, vesselEngine.id)}
            /><div className='input-group-text round_border'>kW</div>
            <Label for="shaft_power">Shaft power</Label>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={6}>
          <Row>
            <Label className='bold_lbl'>Propeller Type</Label>
          </Row>
          <Row>
            <Col lg={3}>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="radio"
                  name="propellerType"
                  id="ccpp"
                  value="controllable_pitch_propeller"
                  defaultChecked={mainEng.length > 0 ? mainEng.filter((item: any) => item.machinery_name === vesselEngine.id)
                    .map((eng: any) => eng.propeller_type === 'controllable_pitch_propeller')[0] : false}
                  onChange={(e: any) => handle_Controllable_Propeller_Main_Engine_Changes(e, index, vesselEngine.id)}
                />
                <label className="form-check-label" htmlFor="vpp">
                  Controllable pitch propeller
                </label>
              </div>
            </Col>
            <Col>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="propellerType"
                  id="fpp"
                  value="fixed_pitch_propeller"
                  defaultChecked={mainEng.length > 0 ? mainEng.filter((item: any) => item.machinery_name === vesselEngine.id)
                    .map((eng: any) => eng.propeller_type === 'fixed_pitch_propeller')[0] : false}
                  onChange={(e: any) => handle_Fixed_Propeller_Main_Engine_Changes(e, index, vesselEngine.id)}
                />
                <label className="form-check-label" htmlFor="fpp">
                  Fixed pitch propeller
                </label>
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg={3}>
          <div className="form-floating input-group mb-3">
            <Input
              type="text"
              className="form-control"
              id={vesselEngine.id}
              name="eedi"
              defaultValue={mainEng.length > 0 ? mainEng.filter((item: any) => item.machinery_name === vesselEngine.id).map((eng: any) => { return eng.eedi }) : null}
              onBlur={(e) => handle_EEDI_Main_Engine_Changes(e, index, vesselEngine.id)}
              placeholder='example'
            /><div className='input-group-text round_border'>gmCO<sub>2</sub>/t-nm</div>
            <Label for="shaft_power">EEDI</Label></div>
        </Col>
        <Col lg={3}>
          <div className="form-floating input-group mb-3">
            <Input
              type="text"
              className="form-control"
              id={vesselEngine.id}
              name="eexi"
              defaultValue={mainEng.length > 0 ? mainEng.filter((item: any) => item.machinery_name === vesselEngine.id).map((eng: any) => { return eng.eexi }) : null}
              onBlur={(e) => handle_EEXI_Main_Engine_Changes(e, index, vesselEngine.id)}
              placeholder='example'
            /><div className='input-group-text round_border'>gmCO<sub>2</sub>/t-nm</div>
            <Label for="shaft_power">EEXI</Label></div>
        </Col>
      </Row>
      <Row className='mb-5'>
        {fpp &&
          <>
            <Col lg={4}>
              <div className="form-floating input-group mb-3">
                <Input
                  type="text"
                  className="form-control"
                  id={vesselEngine.id}
                  name="propeller_pitch"
                  placeholder='example'
                  defaultValue={mainEng.length > 0 ? mainEng.filter((item: any) => item.machinery_name === vesselEngine.id).map((eng: any) => { return eng.propeller_pitch }) : null}
                  onBlur={(e) => handlePitchChanges(e, index, vesselEngine.id)}
                /><div className='input-group-text round_border'>m</div>
                <Label for="shaft_power">Pitch</Label></div>
            </Col>
          </>
        }
        <Col>
          <div className="d-flex flex-wrap">
            <Button type="submit" color='primary' className='pos-end'>Save</Button>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default MainEnginesRow